export default "<app-navbar></app-navbar>\n<app-home></app-home>\n"